<div class="popover-content">
    <ul class="list-unstyled mb-0">
        <li class="mb-2">
            <div class="d-flex align-items-start">
                <div class="fw-normal me-3 text-nowrap account-popover-label">Invitation Status</div>
                <div class="pe-3">
                    <div class="fw-semibold" *ngIf="this.latestInvitation?.email">
                        Sent to {{ this.latestInvitation?.email }}
                    </div>
                    <div class="fw-semibold" *ngIf="!this.latestInvitation?.email">Pending</div>
                    <div class="fw-normal">
                        {{ this.latestInvitation?.sent | formatDateArray : true }}
                    </div>
                </div>
            </div>
        </li>
        <li class="mb-2">
            <div class="d-flex align-items-start">
                <div class="fw-normal me-3 text-nowrap account-popover-label">Registration Status</div>
                <div class="pe-3">
                    <div class="fw-semibold" *ngIf="this.oldestUserSsoLink?.dateCreated">Completed</div>
                    <div class="fw-semibold" *ngIf="!this.oldestUserSsoLink?.dateCreated">Pending</div>
                    <div class="fw-normal">
                        {{ this.oldestUserSsoLink?.dateCreated | formatDateArray : true }}
                    </div>
                </div>
            </div>
        </li>
        <li>
            <div class="d-flex align-items-start">
                <div class="fw-normal me-3 text-nowrap account-popover-label">Email Verification</div>
                <div class="pe-2">
                    <mmoa-email-verification [userDetails]="user" ></mmoa-email-verification>
                </div>
            </div>
        </li>
    </ul>
</div>
